import { RouteConfig } from 'vue-router';
import HostedEmailSecurity from './hostedEmailSecurity.vue';

const hostedEmailSecurity: RouteConfig = {
  path: 'hosted-email-security',
  component: HostedEmailSecurity,
};

export function getDefaultParams() {
  return {};
}

export default hostedEmailSecurity;
